import styled from "styled-components";

export const StyledConsent = styled.div`
  bottom: 0;
  position: fixed;
  width: 100%;
  z-index: 100000;
`;
